const range = (min, max) => ({
  min,
  max
});
const px = num => `${num}px`;
const ranges = {
  xs: range(0, 479.98),
  sm: range(480, 767.98),
  md: range(768, 1023.98),
  lg: range(1024, 1191.98),
  xl: range(1192, 1359.98),
  xxl: range(1360, Infinity)
};
const inMobile = `max-width: ${px(ranges.sm.max)}`;
const inDesktop = `min-width: ${px(ranges.md.min)}`;
export default {
  xs: px(ranges.xs.min),
  xsMax: px(ranges.xs.max),
  sm: px(ranges.sm.min),
  smMax: px(ranges.sm.max),
  md: px(ranges.md.min),
  mdMax: px(ranges.md.max),
  lg: px(ranges.lg.min),
  lgMax: px(ranges.lg.max),
  xl: px(ranges.xl.min),
  xlMax: px(ranges.xl.max),
  xxl: px(ranges.xxl.min),
  inMobile,
  inDesktop,
  ranges
};